module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-25.60800764.png";